const INITIAL_STATE = {
  isAppBlocked: false,
  pendingBillings: [],
  allBillings: [],
  currentRoute: '/',
  historyPush: undefined
}

const billingAndBlockStatusReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_IS_APP_BLOCKED':
      return {...state, isAppBlocked: action.isAppBlocked}
    case 'SET_PENDING_BILLINGS':
      return {...state, pendingBillings: action.pendingBillings}
    case 'SET_CURRENT_ROUTE':
      return {...state, currentRoute: action.currentRoute}
    case 'SET_HISTORY_PUSH':
      return {...state, historyPush: action.historyPush}
    case 'SET_ALL_BILLINGS':
      return {...state, allBillings: action.allBillings}
    default:
      return state
  }
}

export default billingAndBlockStatusReducer



// WEBPACK FOOTER //
// ./src/redux/reducers/billingAndBlockStatusReducer.js